import { AlertTriangle } from 'lucide-react';

export function WhyAIDifferent() {
  return (
    <section className="py-20 sm:py-32 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-xl text-center mb-12">
          <h2 className="text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl lg:text-6xl">
            AI Isn't Like Westlaw
          </h2>
        </div>

        <div className="mx-auto max-w-5xl">
          {/* Image */}
          <div className="mb-12">
            <img
              src="/ai-different.jpg"
              alt="Traditional databases vs AI systems - AI may retain, train on, or expose your data"
              className="w-full rounded-lg shadow-lg"
            />
          </div>

          {/* Explanation */}
          <div className="grid gap-8 md:grid-cols-2">
            <div className="bg-white rounded-lg p-6 border border-gray-200">
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Traditional Databases</h3>
              <p className="text-lg text-gray-600">
                Legal professionals already use external databases—USPTO, Westlaw, court records.
                These are query-response systems. Your search goes out, results come back. Nothing
                is stored. The data you access is public record.
              </p>
            </div>

            <div className="bg-white rounded-lg p-6 border border-red-200">
              <div className="flex items-center gap-2 mb-3">
                <AlertTriangle className="h-5 w-5 text-red-600" />
                <h3 className="text-xl font-semibold text-gray-900">AI Systems</h3>
              </div>
              <p className="text-lg text-gray-600 mb-4">
                When you send client information to an AI provider, that data may be:
              </p>
              <ul className="space-y-2 text-lg text-gray-600">
                <li className="flex items-start gap-2">
                  <span className="text-red-600 font-bold">•</span>
                  <span>
                    <strong>Retained</strong> — Stored indefinitely by the provider
                  </span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-red-600 font-bold">•</span>
                  <span>
                    <strong>Trained on</strong> — Used to improve future AI models
                  </span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-red-600 font-bold">•</span>
                  <span>
                    <strong>Exposed</strong> — Potentially accessed or leaked
                  </span>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-8 text-center">
            <p className="text-xl text-gray-700 max-w-2xl mx-auto font-medium">
              <strong>The risk isn't "being online."</strong> It's client-identifying information in
              AI systems you don't control.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
